import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Order } from 'shell/view-models/order';
import { ResearchTypePracticeVM } from 'practice/view-models/research-type-practice';

export const transformDataset = (values: ResearchTypePracticeVM): string => {
  const transformedFilters: OperationObject = {
    tipoPratica: { value: values.filter?.code || '', operation: Operation.LIKE },
    descrizioneTipoPratica: {
      value: values.filter?.description || '',
      operation: Operation.LIKE,
    },
    tipoRegistro: {
      value: values.filter?.typeRegister || '',
      operation: Operation.EQUALS,
    },
    tipoIniziativa: {
      value: values.filter?.typeInitiative || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = values.filter?.orders || {};
  const ordersMapped: Order = {
    tipoPratica: ordersToTransform?.code,
    descrizioneTipoPratica: ordersToTransform?.description,
    tipoRegistro: ordersToTransform?.register,
    tipoIniziativa: ordersToTransform?.initiative,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
